module.exports = __webpack_public_path__ + "static/media/bg.65b5e4bf.jpg";